<template>
    <div id="user_bind">
        <div class="role_loading" v-if="role_loading">
            <van-loading type="spinner" size="3rem" />
        </div>
        <div class="game_choose" @click="openGamePop">
            <img class="icon" :src="gameIcon" alt="" v-if="gameIcon">
            <div class="icon" v-else></div>
            <div class="name">{{ gameName?gameName:'选择游戏' }}</div>
        </div>
        <div class="content" v-if="!isbind&& show">
            <p>暂无绑定账号</p>
            <el-button type="primary" @click="gotobind">前往绑定</el-button>
        </div>
        <div class="bind_content" v-else-if="isbind && show">
            <el-button class="refresh_btn" type="primary" round :loading="loading2 > 0" @click="refresh">
                <van-icon name="replay" />刷新
            </el-button>

            <div class="box" v-for="(it,index) in role" :key="index">
                <div class="account_role">
                    <div class="account">
                        <van-image class="user" :src="require('../../assets/version_1.3.0/sell/user.png')"/>
                        账号：
                        <span>{{ it.game_account }}</span>
                    </div>
                    <!-- <div class="role">
                        <span class="total">共有角色{{ it.roleList.length }}个</span>
                        <el-button class="unbind" :loading="it.isloading" type="primary" @click="opeUnbind(it,it.account_id,index)">解绑账号</el-button>
                    </div> -->
                    <!-- <van-icon name="cross" class="close" @click="opeUnbind(it,it.account_id,index)" v-if="prop_trade == 1 && role_trade == 0"/> -->
                    <van-icon name="cross" class="close" @click="opeUnbind(it,it.id,index)"/>
                </div>
                <!-- <ul class="account_list" v-if="prop_trade == 1 && role_trade == 0">
                    <li class="account_item" v-for="(item,i) in it.roleList" :key="i">
                        {{ item.server_name }} {{ item.role_name }}
                    </li>
                </ul> -->
                <div class="child" v-if="it.child_list">
                    <ul>
                        <li class="child_item" v-for="(its,k) in it.child_list" :key="k">
                            <div>{{ its.nickname }}</div>
                            <div class="sell_btns">
                                <el-button class="sell prop" @click="sell(1,it.id,it.game_account,its.jh_user_id)" v-if="prop_trade == 1">卖道具</el-button>
                                <el-button class="sell role" @click="sell(2,it.id,it.game_account,its.jh_user_id)" v-if="role_trade == 1">卖角色</el-button>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="sell_btns" v-else>
                    <el-button class="sell prop" @click="sell(1,it.id,it.game_account)" v-if="prop_trade == 1">卖道具</el-button>
                    <el-button class="sell role" @click="sell(2,it.id,it.game_account)" v-if="role_trade == 1">卖角色</el-button>
                </div>
  
            </div>
            <el-button class="bind_more" type="primary" @click="gotobind">绑定更多账号</el-button>
        </div>
    </div>
</template>
<script>
    import $ from 'jquery'
    export default {
        data() {
            return {
                isbind: true, //是否绑定账号
                role: [],
                show: false,
                loading: 0,
                loading2: 0,
                role_loading: false
            }
        },
        computed: {
            gameIcon() {
                return this.$store.state.gameIcon
            },
            gameId() {
                return this.$store.state.gameId
            },
            gameName() {
                return this.$store.state.gameName
            },
            prop_trade() {
              return this.$store.state.prop_trade
            },
            role_trade() {
              return this.$store.state.role_trade
            },
        },
        mounted() {
           
        },
        methods: {
            //打开选择游戏
            openGamePop() {
                this.$filterPop({
                    type: 'game'
                })
            },
            gotobind() {
                this.$router.push({
                    name: 'user.bindrole'
                })
            },
            //检查用户是否绑定账号
            checkBindAccount(app_id,index) {
                this.$Ajax('user-info/check-bind-account', {
                    app_id
                }).then(rs => {
                    this.show = true
                    if (rs.code == 200) {
                        this.isbind = rs.data.is_bind
                        if (this.isbind) {
                            this.getUserRoleList(app_id,index)
                        }else {
                            this.role = []
                            // this.$store.commit('setBindrole', {
                            //     role_id: '',
                            //     role_name: '',
                            //     server_id: '',
                            //     server_name: ''
                            // })
                        }
                    } else {
                        this.role = []
                        // this.$store.commit('setBindrole', {
                        //     role_id: '',
                        //     role_name: '',
                        //     server_id: '',
                        //     server_name: ''
                        // })
                        this.isbind = false
                    }
                })
            },
            //获取角色列表
            getUserRoleList(app_id,index) {
                var that = this
                var api = 'user-info/accounts'
                // if(this.prop_trade == 1 && this.role_trade == 0) {
                //     api = 'user-info/user-role-list'
                // }else {
                //     api = 'user-info/accounts'
                // }
                this.$Ajax(api, {
                    app_id
                }).then(rs => {
                    this.show = true
                    if (rs.code == 200) {
                        this.role = rs.data
                    } else {
                        this.role = []
                    }
                }).finally(() => {
                    that.loading2 = 0
                })
            },
            //打开解绑验证码弹框
            opeUnbind(it,account_id,index) {
                var that = this
                this.$set(it,'isloading',true)
                setTimeout(() => {
                    this.$set(it,'isloading',false)
                }, 2000)
                this.$RModal.unbind({
                    selection: {
                        app_id: that.gameId,
                        account_id
                    },
                    onSuccess: () => {
                        that.checkBindAccount(that.gameId,index)
                    }
                })
            },
            //刷新角色列表
            refresh() {
                this.role = []
                this.loading2++
                this.getUserRoleList(this.gameId)
            },
            chooseRole(role_id,role_name,server_id,server_name) {
                this.$store.commit('setBindrole', {
                    role_id,
                    role_name,
                })
                this.$store.commit('bindServer',{
                    server_id,
                    server_name
                })
            },
            // 选择卖道具or角色
            sell(index,account_id,account,child_user_id) {
                var that = this
                this.$filterPop({
                    type: 'roleserver',
                    direction: 'up',
                    onSuccess: (data) => {
                        //
                        that.role_loading = true
                        this.$Ajax('goods-role/cp-rolelist',{
                            app_id: that.gameId,
                            account_id,
                            server_id: data.server_id,
                            child_user_id
                        },'post',{
                            timeout: 35000  // 设置35秒超时
                        }).then(rs => {
                            if(rs.code == 200) {
                                that.role_loading = false
                                if(rs.data.length > 0) {
                                    this.$RModal.accounts({
                                        noheader: true,
                                        selection: {
                                            app_id: that.gameId,
                                            account_id,
                                            icon: that.gameIcon,
                                            roles: rs.data,
                                            index,
                                            account,
                                            child_user_id
                                        },
                                        onSuccess: (info) => {
                                            that.chooseRole(info.role_id,info.role_name,info.server_id,info.server_name)
                                            this.$router.push({name: 'sell'})
                                        }
                                    })
                                }else {
                                    // 没查到角色 弹框
                                    this.$RModal.norole({
                                        noheader: true
                                    })
                                }
                            }else if(rs.code == 406){
                                that.role_loading = false
                                // 没查到角色 弹框
                                this.$RModal.norole({
                                    noheader: true,
                                    selection: {
                                        message: rs.msg
                                    }
                                })
                            }else {
                                that.role_loading = false
                            }
                        })
                    }
                })
            }
        },
        watch: {
            gameId: {
                immediate: true,
                handler(e) {
                    if(e) {
                        this.checkBindAccount(e)
                    }else {
                        this.$filterPop({
                            type: "game"
                        });
                    }
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    #user_bind {
        padding-top: 1rem;
        position: relative;

        .game_choose {
            position: absolute;
            right: 0;
            top: 2rem;
            width: 9.5rem;
            height: 3.6rem;
            background-color: var(--chooseBg);
            // border: 0.15rem solid var(--borderColor);
            border-right: none;
            border-top-left-radius: 10rem;
            border-bottom-left-radius: 10rem;
            display: flex;
            align-items: center;
            padding-left: 0.1rem;
            overflow: hidden;
            cursor: pointer;

            .icon {
                width: 3.4rem;
                height: 3.4rem;
                border-radius: 0.8rem;
                border-radius: 50%;
                background-color: #f2f2f2;
            }

            .name {
                flex: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: center;
                font-size: 1.2rem;
                transform: scale(0.98);
            }
        }

        .content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 12rem 0;
            padding-right: 1.2rem;

            p {
                margin-bottom: 2rem;
                font-size: 1.4rem;
                color: #aaa;
            }

            .el-button {
                border-radius: 10rem;
                padding: 0.8rem 6rem;
                font-size: 1.2rem;
            }
        }

        .bind_content {
            margin-top: 1.3rem;
            padding-right: 1.2rem;
            .refresh_btn {
                margin-bottom: 2rem;
                font-size: 1.2rem;
                padding: 0;
                width: 6rem;
                height: 2.5rem;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .box {
                padding: 0;
                background-color: #FFE4D8;
                margin-bottom: 1.6rem;
                border-radius: 1rem;
                // height: 7.9rem;
                overflow: hidden;

                .account_role {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-radius: 1rem;
                    background: url(../../assets/version_1.3.0/sell/money.png) no-repeat 100% 0 / 5.8rem 6.1rem;
                    color: #000;
                    font-size: 1.4rem;
                    padding: 0.8rem 1rem;
                   
                    .account {
                        font-size: 1.5rem;
                        display: flex;
                        align-items: center;
                        .user {
                            width: 1.8rem;
                            height: 1.8rem;
                            margin-right: 0.4rem;
                        }
                    }

                    .role {
                        height: 2.4rem;
                        line-height: 2.4rem;
                        text-align: center;
                        border-radius: 10rem;
                        color: #fff;
                        font-size: 1.2rem;
                        display: flex;
                        align-items: center;
                        .total {
                            background-color: var(--theme);
                            width: 10rem;
                            height: 100%;
                            display: inline-block;
                            border-radius: 100rem;
                            font-size: 1.2rem;
                        }
                        .el-button {
                            padding: 0;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            height: 100%;
                            width: 8rem;
                            font-size: 1.2rem;
                            margin-left: 1rem;
                        }
                    }
                    .close {
                        background-color: #ffefe4;
                        border-radius: 50%;
                        color: #FF854B;
                        font-size: 1.2rem;
                        padding: 0.2rem;
                        cursor: pointer;
                    }
                }

                .account_list {
                    .account_item {
                        padding: 1.2rem 2rem;
                        background-color: #fff;
                        font-size: 1.3rem;
                        margin: .6rem 1rem;
                        border-radius: .8rem;
                    }
                }
                .sell_btns {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 0.9rem 1rem;
                    border-radius: 1rem;
                    background-color: #fff;
                    .sell {
                        flex: 1;
                        //width: 16rem;
                        height: 3rem;
                        line-height: 3rem;
                        text-align: center;
                        padding: 0;
                        font-size: 1.4rem;
                        border: none;
                        color: #fff;
                        margin-right: 1.5rem;
                        border-radius: 0.5rem;
                        &:nth-last-child(1) {
                            margin: 0;
                        }
                        &.prop {
                            background: url(../../assets/version_1.3.0/sell/props.png) no-repeat 100% 0 / 3.3rem 3rem;
                            background-color: #FF7056;
                        }
                        &.role {
                            background: url(../../assets/version_1.3.0/sell/role.png) no-repeat 100% 0 / 3.5rem 3rem;
                            background-color: #FF854B;
                        }
                    }
                }
            }
        }

        .unbind {
            display: block;
            margin: 0 auto;
            width: 18rem;
            height: 3rem;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 10rem;
        }
        .bind_more {
            margin: 2rem auto;
            padding: 0;
            width: 12rem;
            height: 3.6rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 1.2rem;
        }
    }
    .child {
        background-color: #fff;
        padding: 1.2rem 1rem;
        .child_item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 .4rem 0 1rem;
            border: 1px solid rgba(246, 111, 48, 0.3);
            border-radius: .7rem;
            margin-bottom: .9rem;
            &:nth-last-child(1) {
                margin-bottom: 0;
            }
            .sell_btns {
                padding: .4rem .3rem !important;
                .sell {
                    margin-right: .6rem !important;
                    width: 7rem;
                    /deep/span {
                        font-size: 1.2rem;
                        transform: scale(0.9);
                        display: block;
                        text-align: left;
                        padding-left: 1rem;
                    }
                    &.prop {
                        background: url(../../assets/version_1.3.0/sell/props.png) no-repeat 100% .2rem / 2.7rem 2.4rem !important;
                        background-color: #FF7056 !important;
                    }
                    &.role {
                        background: url(../../assets/version_1.3.0/sell/role.png) no-repeat 100% .2rem / 2.7rem 2.4rem !important;
                        margin: 0 !important;
                        background-color: #FF854B !important;
                    }
                }
            }
        }
    }
</style>